<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" size="medium" disabled :placeholder="placeholder"/>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" v-model="_value" size="medium" clearable :placeholder="placeholder"/>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <field v-model="_value" type="number" :placeholder="placeholder"/>
    </div>
    <div v-else>
      <!-- 🔥 修复：空值不显示 NaN -->
      {{ _value || '' }}
    </div>
    <!--    <div v-else>
      <field readonly clickable v-model="_value" type="number" @click="showKey = true" :placeholder="placeholder"></field>
      <number-keyboard v-model="_value" theme="custom" :extra-key="['-', '.']"
                       close-button-text="完成" :show="showKey" :maxlength="15" @blur="showKey = false"/>
    </div>-->
  </div>
</template>

<script>
import { Field, NumberKeyboard } from 'vant'
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "NumberInput",
  components: {Field, NumberKeyboard},
  props:{
    value:{
      type: Number,
      default: undefined
    },
    placeholder:{
      type: String,
      default: '请输入数值'
    },
    precision:{
      type: Number,
      default: 0
    }
  },
  computed:{
    _value:{
      get(){
        return this.parseNumber(this.value);
      },
      set(val){
        this.$emit('input', this.parseNumber(val))
      }
    }
  },
  data() {
    return {
      showKey: false
    }
  },
  created() {
    // 🔥 修复：默认值不给 0，给 null，小程序不报错
    if (this.value == undefined) {
      this.value = null
    }
  },
  methods: {
    parseNumber(val){
      // 🔥 核心修复：空值返回 null，不转 NaN
      if (val === null || val === undefined || val === '') {
        return null
      }

      if (typeof(val) === 'string'){
        return this.precision > 0 ? parseFloat(parseFloat(val).toFixed(this.precision)):parseInt(val)
      }
      return val
    },
    isNaN(value){
      return typeof value === 'number' && isNaN(value)
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner{
  text-align: left;
}
</style>